import React from "react";
import { useTranslation } from "react-i18next";

export interface IShowLastYearSelectProps {
  usePrevYear: boolean;
  setUsePrevYear: (usePrevYear: boolean) => void;
}

export const ShowLastYearSelect = (props: IShowLastYearSelectProps) => {
  const { usePrevYear, setUsePrevYear } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`analysisCollectionsPage.collectionChartArea.${key}`);

  return (
    <div className="chart-choose-last-year-module">
      <button
        onClick={() => {
          setUsePrevYear(!usePrevYear);
        }}
      >
        <input type="checkbox" checked={usePrevYear} readOnly={true} />
        <p>{t("usePrevYear")}</p>
      </button>
    </div>
  );
};
